export default __webpack_public_path__ + "static/media/case-study3.39ca9095.jpg";